export type ConnectionState = {
  socketErr: null | Record<string, unknown>;
  isConnected: boolean;
};

export default {
  socketErr: null,
  isConnected: false,
} as ConnectionState;
